import type { DevicesState } from './types'

const state = (): DevicesState => ({
  // All state members here are objects where first level keys are the device id
  accountId: {},
  coords: {},
  model: {},
  submodel: {},
  serial: {},
  indoor: {},
  name: {},
  locationName: {},
  public: {},
  shared: {},
  privacyZone: {},
  sensorReadings: {},
  deviceStatus: {},
  sensorStatus: {},
  rssi: {},
  connectionType: {},
  averages: {},
  percentChanged: {},
  lastCommunicationTime: {},
  lastTelemetry: {},
  lastState: {},
  lastTelemetryStudyId: {},
  latestStudy: {},
  firmware: {},
  mqttHost: {},
  sensorEoL: {},
  userCals: {},
  zeroAppliedAt: {},
  zeroState: {},
  measurements: {},
  allDevices: {},
  allUserDevices: {},
  subscriptionMetadata: {},
  subscriptionType: {},
  connectedSmartBridgeModel: {},
  connectedSmartBridgeSerial: {},
  isConnected: {},
  isTelemetry24HrsActive: {},
  telemTxType: {},
  uploadStatus: {},
  batteryCharging: {},
  batteryInstalled: {},
  batteryLow: {},
  batteryRemaining: {},
  calibrationDate: {},
  flowCalibrationFactor: {},
  userCal: {},
  errorState: {},
  alarms: {}
})

export default state
